import React from 'react';
import { LayersIcon, ImageIcon } from 'lucide-react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle, faBolt, faRocket } from '@fortawesome/free-solid-svg-icons';
import { Template } from '../lib/data';
import { Card, CardContent } from './ui/Card';
import { Badge } from './ui/Badge';
import { Button } from './ui/Button';
interface TemplateCardProps {
  template: Template;
}
export function TemplateCard({
  template
}: TemplateCardProps) {
  return <Card className="group overflow-hidden border-border hover:border-blue-300 hover:shadow-md transition-all duration-300 flex flex-col h-full" data-id="element-195">
      {/* Placeholder Image Area */}
      <div className="aspect-video w-full bg-muted relative p-3 flex flex-col justify-between" data-id="element-196">
        <div className="flex justify-between items-start" data-id="element-197">
          <Badge variant="secondary" className="bg-background/90 text-foreground hover:bg-background border-none shadow-sm" data-id="element-198">
            {template.category}
          </Badge>
        </div>

        {/* Image placeholder icon */}
        <div className="absolute inset-0 flex items-center justify-center" data-id="element-199">
          <ImageIcon className="w-10 h-10 text-muted-foreground/40" data-id="element-200" />
        </div>

        <div className="flex justify-between items-end relative z-10" data-id="element-201">
          <div className="text-xs font-medium text-muted-foreground bg-background/80 px-2.5 py-1 rounded shadow-sm" data-id="element-202">
            {template.bestForTag}
          </div>
        </div>
      </div>

      {/* Content Area */}
      <CardContent className="px-3 py-3 flex flex-col flex-grow" data-id="element-203">
        <div className="flex items-start justify-between gap-2 mb-1" data-id="element-204">
          <h3 className="font-semibold text-sm text-foreground group-hover:text-blue-600 transition-colors" data-id="element-205">
            {template.title}
          </h3>
          {template.difficulty === 'Beginner' && <Badge variant="success" className="flex-shrink-0 whitespace-nowrap gap-1.5" data-id="element-206">
              <FontAwesomeIcon icon={faCheckCircle} className="w-3 h-3" data-id="element-207" /> Super
              Easy
            </Badge>}
          {template.difficulty === 'Intermediate' && <Badge variant="warning" className="flex-shrink-0 whitespace-nowrap gap-1.5" data-id="element-208">
              <FontAwesomeIcon icon={faBolt} className="w-3 h-3" data-id="element-209" /> A Little
              Work
            </Badge>}
          {template.difficulty === 'Advanced' && <Badge variant="info" className="flex-shrink-0 whitespace-nowrap gap-1.5" data-id="element-210">
              <FontAwesomeIcon icon={faRocket} className="w-3 h-3" data-id="element-211" /> For Pros
            </Badge>}
        </div>

        <p className="text-xs text-muted-foreground line-clamp-2 mb-3 flex-grow" data-id="element-212">
          {template.description}
        </p>

        <div className="flex items-center justify-between mt-auto pt-3 border-t border-border" data-id="element-213">
          <div className="flex items-center text-muted-foreground text-xs font-medium" data-id="element-214">
            <LayersIcon className="w-3.5 h-3.5 mr-1" data-id="element-215" />
            {template.stepCount} pages
          </div>
          <Button variant="outline" size="sm" className="px-3 py-1.5 h-auto text-xs font-semibold hover:bg-blue-50 hover:text-blue-600 hover:border-blue-200" data-id="element-216">
            Use This →
          </Button>
        </div>
      </CardContent>
    </Card>;
}